import React from 'react';
import { createRoot } from 'react-dom/client';
import domReady from '@wordpress/dom-ready';
import { ShortlistSidebar } from './components/ShortlistSidebar';
import { dispatchOpenShortlist, getShortlist, SHORTLIST_CHANGE_EVENT, ShortlistItem } from '../../_shared/shortlist';

const PULSE_CLASS = 'is-pulsing';
const PULSE_DURATION_MS = 600;

domReady(() =>
	{
	const triggers = document.querySelectorAll<HTMLButtonElement>('.wp-block-ocean-shortlist__trigger');
	if (triggers.length === 0)
		{
		return;
		}

	// Badge is injected client-side rather than rendered in save()/render.php
	// -- the count depends on this visitor's localStorage, and baking it into
	// the block's own markup would defeat page caching for anyone else.
	const counts = Array.from(triggers).map((trigger) =>
		{
		const count = document.createElement('span');
		count.className = 'wp-block-ocean-shortlist__count';
		trigger.appendChild(count);
		return count;
		});

	const applyCount = (items: ShortlistItem[], pulse: boolean) =>
		{
		const hasItems = items.length > 0;

		counts.forEach((count) =>
			{
			count.textContent = hasItems ? String(items.length) : '';
			});

		triggers.forEach((trigger) => trigger.classList.toggle('has-items', hasItems));

		if (!pulse)
			{
			return;
			}

		triggers.forEach((trigger) =>
			{
			trigger.classList.remove(PULSE_CLASS);
			void trigger.offsetWidth; // restart the animation if it's still running
			trigger.classList.add(PULSE_CLASS);
			window.setTimeout(() => trigger.classList.remove(PULSE_CLASS), PULSE_DURATION_MS);
			});
		};

	applyCount(getShortlist(), false);

	// Fires whenever any "Add/remove from shortlist" button on the page is
	// clicked (see property-shortlist/src/run.tsx) -- keeps the nav count and
	// pulse in sync without the two blocks knowing about each other directly.
	window.addEventListener(SHORTLIST_CHANGE_EVENT, (event) =>
		{
		applyCount((event as CustomEvent<ShortlistItem[]>).detail || [], true);
		});

	triggers.forEach((trigger) =>
		{
		trigger.addEventListener('click', () => dispatchOpenShortlist());
		});

	// One sidebar instance for the whole page, however many trigger buttons
	// (e.g. one per nav menu) point at it -- see ShortlistSidebar.tsx.
	const mount = document.createElement('div');
	document.body.appendChild(mount);
	createRoot(mount).render(<ShortlistSidebar />);
	});
